import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#D95324',
    },
    secondary: {
      main: '#6C2F85',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
